import React from "react"
import SEO from "../components/seo"
import Header from "../components/Header/header"
import BlogHero from "../components/BlogHero/BlogHero"
import BlogList from "../components/BlogList/BlogList"

const BlogPage = () => {

  return (
    <>
      <SEO title="Blog" />
      <Header />
      <BlogHero />
      <BlogList />
    </>
  )
}

export default BlogPage
